import { FC, memo } from 'react';
import { ProxyServerAddress } from '../../entities';
import { ProxyServerHealthStatuses } from '../../proxyServerAddresses.interfaces';
import { Spin, Tag, Tooltip } from 'antd';
import { EmojiDizzyFill, HeartFill } from 'react-bootstrap-icons';

interface Props {
  healthStatus: ProxyServerAddress['healthStatus'];
  simple?: boolean;
}

export const ProxyServerAddressesHealthTag: FC<Props> = memo(({ healthStatus, simple = false }) => {
  const text = simple ? '' : <>Стан:&nbsp;</>;

  if (healthStatus === ProxyServerHealthStatuses.Working) {
    return (
      <Tooltip title="працює">
        <Tag color="success" bordered={ !simple }>
          { text }
          <HeartFill/>
        </Tag>
      </Tooltip>
    );
  }

  if (healthStatus === ProxyServerHealthStatuses.NotWorking) {
    return (
      <Tooltip title="не працює">
        <Tag color="error" bordered={ !simple }>
          { text }
          <EmojiDizzyFill/>
        </Tag>
      </Tooltip>
    );
  }

  if (healthStatus === ProxyServerHealthStatuses.Checking) {
    return (
      <Tooltip title="перевірка">
        <Tag color="geekblue" bordered={ !simple }>
          { text }
          <Spin size="small" spinning/>
        </Tag>
      </Tooltip>
    );
  }
});
